<div class="dynamic-datepicker">
    <mat-form-field appearance="outline" class="example-form-field" *ngIf="isEditMode()">
        <mat-label>{{data.columnName}}</mat-label>
        <input matInput [matDatepicker]="datepicker"  [(ngModel)]="inputValue" (dateChange)="onDateChange($event)">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
        <mat-datepicker #datepicker>
        </mat-datepicker>
      </mat-form-field>
    
    <mat-label *ngIf="!isDateEmpty() && !isEditMode()" style="font-size: 10px;">{{data.columnName}}</mat-label>
    <mat-chip-list *ngIf="!isEditMode()" class="chip-edit" >
      <mat-chip *ngIf="!isDateEmpty()" class="chip-edit" color="primary" selected (click)="switchEditingMode()"> 
        {{getDateToRender()}}
      </mat-chip>
      <mat-chip (click)="switchEditingMode()" *ngIf="isDateEmpty()"> 
        {{data.columnName}}: 
      </mat-chip>
    </mat-chip-list>
    
    <i class="fas fa-solid fa-angle-up icon" *ngIf="isEditMode()" (click)="switchEditingMode()"></i>
  </div>
